import { QueryFilterParameter } from './../../widgets/filters/models/query-filter-parameter.model'

export class FcValGrphInptData {
  action: string;
  pageNo: string;
  pageSize: string;
  RoleId: string;

}

export class FCValGrphOutputData {
  fcValDatalst: object;
  fcValItemDatalst: FcValItemDetails[];
  fcValGrphDatalst: FcOverviewGrphDimensions[];
  fcValGrphlst: FcGrphType[];
  updtclntresp: Updateclientresponse[];
  ForecastObjectId: any;
  barData: any;
}

export class FcValidationOverviewData {
  ForecastObjectId: number | null;
  ForecastObjectClientId: string;
  Actual12: number | null;
  Actual11: number | null;
  Actual10: number | null;
  Actual9: number | null;
  Actual8: number | null;
  Actual7: number | null;
  Actual6: number | null;
  Actual5: number | null;
  Actual4: number | null;
  Actual3: number | null;
  Actual2: number | null;
  Actual1: number | null;
  Consumption12Mth: number | null;
  Forecast12Mth: number | null;
  Forecast1: number | null;
  Forecast2: number | null;
  Forecast3: number | null;
  Forecast4: number | null;
  Forecast5: number | null;
  Forecast6: number | null;
  Forecast7: number | null;
  Forecast8: number | null;
  Forecast9: number | null;
  Forecast10: number | null;
  Forecast11: number | null;
  Forecast12: number | null;
  RowNum: number | null;
  Warehouse: string;
  Brand: string;
  ItemGroupLevel1: string;
  ItemGroupLevel2: string;
  ItemGroupLevel3: string;
  ItemGroupLevel4: string;
  SegmentName: string;
  Clientcomment: string;
  HeaderName: string;
  Issue: string;
  ClientResponse: string;
  ValidationId: number | null;
}

export class FcValItemDetails {
  caption: string;
  dataField: string;
  selectGroup: string;
}
export class FcOverviewGrphDimensions {
  name: string;
  value: string;
}
export class FcGrphType {
  value: string;
  name: string;
  id: number;
}

export class Updateclientresponse {
  forecastobjid: string;
  clientresponse: string;
  flag: number;
  msg: string;
}


export class FcValGrphInptDataFilterData {
  action: string;
  pageNo: number;
  pageSize: number;
  RoleId: string;
  Filters: QueryFilterParameter[];
}

export class ForecastElementDataNew {
  forecastElementName: string;
  userInput: boolean;
  forecastElementId: number;
}


export class UpdateForecastElementData {
  roleid: number;
  ForecastElement: UpdateForecastElementDataNew[]; 
}

export class UpdateForecastElementDataNew {
  ForecastElementId: number;
  UserInput: boolean; 
  ElementName: string;  
}

export class CaptionArray {
   name : string 
   value : string 
}
